import * as signalR from '@microsoft/signalr';

export const createConnection = (hubUrl: string) => {
  const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${hubUrl}/moodhub`)
      .withAutomaticReconnect()
      .build();

  return connection;
};

export const startConnection = async (connection: signalR.HubConnection) => {
  try {
      await connection.start();
  } catch (err) {
      console.error("Error while starting connection: ", err);
      setTimeout(() => startConnection(connection), 5000); // Retry connection
  }
};

export const registerOnMessageReceived = (connection: signalR.HubConnection, methodName: string, callback: (user: string, message: string) => void) => {
  connection.on(methodName, callback);
};

export const unregisterOnMessageReceived = (connection: signalR.HubConnection, methodName: string) => {
  connection.off(methodName);
}

export const closeConnection = async (connection: signalR.HubConnection) => {
  try {
    await connection.stop();
  } catch (err) {
    console.error("Error on closing connection: ", err);
  }
}
